import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import { createPermission } from 'Permission/Domain/Services/CreatePermissionService';
import { useParams } from 'react-router';
import { getPermission } from 'Permission/Domain/Services/GetPermissionService';
import { patchPermission } from 'Permission/Domain/Services/PatchPermissionService';
import { getPermissionsList } from 'Permission/Domain/Services/GetPermissionsListService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { PRIVATE_ADMIN_LIST_PERMISSIONS } from '../Constants/PathsConstant';
import { useTranslation } from 'react-i18next';

function FormPermissionView() {
  const {t} = useTranslation();

  const {id} = useParams();
  
  const [sku, setSku] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('GENERAL');
  const [existingCategories, setExistingCategories] = useState(['Extras', 'Usuarios', 'Organigrama', 'Propuesta Proyectos', 'Delegaciones Servicios', 'Objetivos', 'GENERAL']);
  const [sendingApiRequest, setSendingApiRequest] = useState(false);

  useEffect(() => {
    getPermissionsList({ limit: 1000 }).then((response) => {
      if (response && response.records) {
        const cats = Array.from(new Set(response.records.map(p => p.category).filter(Boolean)));
        if (cats.length > 0) {
          setExistingCategories(Array.from(new Set([...cats, 'Extras', 'Usuarios', 'GENERAL'])));
        }
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (id !== "new") {
      setSendingApiRequest(true);
      getPermission(id).then((response) => {
        setSku(response.sku || '');
        setDescription(response.description || '');
        setCategory(response.category || 'GENERAL');
        setSendingApiRequest(false);
      });
    }
  }, [id]);

  const handleSkuChange = (event) => setSku(event.target.value);
  const handleDescriptionChange = (event) => setDescription(event.target.value);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      var apiResponse = null;
      if (sendingApiRequest) return;
      setSendingApiRequest(true);
      if (id === "new") {
        apiResponse = await createPermission({
          sku: sku,
          description: description,
          category: category || 'GENERAL'
        });
      } else {
        apiResponse = await patchPermission(id, {
          sku: sku,
          description: description,
          category: category || 'GENERAL'
        });
      }
      setSendingApiRequest(false);
      if (apiResponse !== null) {
        window.location.href = process.env.PUBLIC_URL + PRIVATE_ADMIN_LIST_PERMISSIONS;
      }
    } catch (error) {
      //console.error(error);
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <h1>{id === "new" ? t('permission.form.create') : t('permission.form.update')}</h1>
      <form onSubmit={handleSubmit} style={{ width: '50%' }}>
        <TextField
          style={{ width: '100%' }}
          required
          label={t('permission.form.sku')}
          variant="outlined"
          value={sku}
          onChange={handleSkuChange}
        />
        <br/><br/>
        <TextField
          style={{ width: '100%' }}
          required
          label={t('permission.form.description')}
          variant="outlined"
          value={description}
          onChange={handleDescriptionChange}
        />
        <br/><br/>
        <Autocomplete
          freeSolo
          options={existingCategories}
          value={category}
          onChange={(event, newValue) => {
            setCategory(newValue || 'GENERAL');
          }}
          onInputChange={(event, newInputValue) => {
            setCategory(newInputValue || 'GENERAL');
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              label={t('permission.form.category')}
              variant="outlined"
              helperText="Selecciona una categoría existente (ej. Extras, Usuarios) o escribe una nueva"
            />
          )}
        />
        <br/><br/>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" color="primary" type="submit">
            {id === "new" ? t('permission.form.create') : t('permission.form.update')}
          </Button>
          <Button variant="contained" color="error" href={process.env.PUBLIC_URL + PRIVATE_ADMIN_LIST_PERMISSIONS}>
            {t('permission.form.cancel')}
          </Button>
        </Box>
      </form>
      <DialogLoader open={sendingApiRequest} />
    </Box>
  );
}

export default FormPermissionView;
